/* Shared formatters + the pinned "today" used by the dummy-data generators.
   Mirrors PS.fmt / PS.TODAY from the mockup core.js. */

// Mockup pins "today" to 2026-05-31 so the seeded May-2026 data reads sensibly.
export const TODAY = new Date('2026-05-31T12:00:00')

export const inr = (n) => (n == null || isNaN(n) ? '—' : '₹' + Number(n).toLocaleString('en-IN'))

export const money = (n) => {
  if (n == null || isNaN(n)) return '—'
  const x = Number(n)
  if (x >= 1e7) return '₹' + (x / 1e7).toFixed(2) + ' Cr'
  if (x >= 1e5) return '₹' + (x / 1e5).toFixed(2) + ' L'
  return '₹' + x.toLocaleString('en-IN')
}

export const fmtDate = (d) => {
  if (!d) return '—'
  const x = new Date(d)
  return x.toLocaleDateString('en-GB', {day: '2-digit', month: 'short', year: 'numeric'})
}

export const fmtDateTime = (d) => {
  if (!d) return '—'
  const x = new Date(d)
  return (
    x.toLocaleDateString('en-GB', {day: '2-digit', month: 'short', year: 'numeric'}) +
    ', ' +
    x.toLocaleTimeString('en-GB', {hour: '2-digit', minute: '2-digit'})
  )
}

export const relDays = (d) => {
  if (!d) return null
  return Math.round((TODAY - new Date(d)) / 86400000)
}

export const relLabel = (d) => {
  const days = relDays(d)
  if (days == null) return '—'
  if (days <= 0) return 'today'
  if (days === 1) return '1 day ago'
  if (days < 30) return days + ' days ago'
  if (days < 60) return '1 mo ago'
  return Math.round(days / 30) + ' mo ago'
}

export const initials = (n) =>
  String(n || '?')
    .split(/\s+/)
    .slice(0, 2)
    .map((w) => w[0])
    .join('')
    .toUpperCase()
